import styled from "@emotion/styled";
import React from "react";
import { ActivityDetailQuery_activity, ENUM_ACTIVITY_PRICETYPE } from "../../graphql/types";
import Box from "../Box";
import Flex from "../Flex";
import Markdown from "markdown-to-jsx";
import Gallery from "../Gallery";
import Map from "../Map";
import { useTranslation } from "next-i18next";
import AddToBasket from "../basket/AddToBasket";
import Reviews from "../Reviews";

interface Props {
  activity?: ActivityDetailQuery_activity | null;
}

const ActivityDetail = ({ activity }: Props) => {
  const { t } = useTranslation("common");
  const onlyValue = activity?.values?.[0];
  const isPerActivity = activity?.priceType === ENUM_ACTIVITY_PRICETYPE.perActivity;
  return (
    <>
      <ActivityDetailContainer
        flexDirection={{ _: "column", md: "row" }}
        alignItems="flex-start"
        mb={5}
      >
        <Box width={{ _: 1, md: 2 / 4 }}>
          <Gallery images={activity?.images} width={630} height={400} />
        </Box>
        <Flex
          ml={{ _: 0, md: 6 }}
          mt={{ _: 3, md: 0 }}
          width={1}
          flexDirection="column"
          alignItems={{ _: "center", md: "flex-start" }}
        >
          <Box width={{ _: 1, lg: 0.7 }} mb={3}>
            <Markdown>{activity?.longDescription || ""}</Markdown>
          </Box>
          <PriceText>
            {t(isPerActivity
              ? "currencyPerActivity"
              : "currencyPerPerson",
              { price: onlyValue?.price?.amount })
            }
          </PriceText>
          <AddToBasket
            type="activity"
            disableIncrease={isPerActivity}
            minAmount={activity?.minAmountOfPeople || undefined}
            id={activity?.id}
            slug={activity?.slug}
            title={activity?.title}
            value={onlyValue}
            priceType={activity?.priceType}
          />
        </Flex>
      </ActivityDetailContainer>
      {!!activity?.reviews?.length && <Reviews reviews={activity?.reviews} />}
      <Map coordinates={[activity?.coordinates]} />
    </>
  );
};

const ActivityDetailContainer = styled(Flex)``;

export default ActivityDetail;

const PriceText = styled.span`
  text-transform: uppercase;
  font-weight: 700;
`;
